import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Feminine Hijinx by Dodie Bellamy | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Already a member of The Feminist Writers’ Guild and one of the principal founders/proponents of the New Narrative movement, Dodie Bellamy published her first book with Hanuman Books in 1991.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/DodieBellamy_Mockup1.webp', '../../Series-One/DodieBellamy_Mockup2.webp', '../../Series-One/DodieBellamy_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Feminine Hijinx</h1>
            <div className='productAuthor'>Dodie Bellamy</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378029'} />
            <div className='productPrice'>$12.99 USD</div>
          </div>


          <div className='productDescription'>Already a member of The Feminist Writers’ Guild and one of the principal founders/proponents of the New Narrative movement, Dodie Bellamy published her first book with Hanuman Books in 1991. <em>Feminine Hijinx</em> brings together two long pieces, "Complicity" and "The Debbies I Have Known", along with a new introduction by the author, written for this reissue.
          </div>
          <div className='productDescription'>
            <p><strong>Dodie Bellamy</strong> (b. 1951) is an American writer, journalist, and educator, most often associated with the New Narrative movement. She is the author of <em>The Letters of Mina Harker, Cunt-ups, Pink Steam, The TV Sutras</em>, and co-edited <em>Writers Who Love Too Much: New Narrative Writing 1977–1997</em> with Kevin Killian.</p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Autumn 2023</div>
            <div>ISBN 9798989378029</div>
            <div>4.125 x 2.75 x 0.54 inches</div>
            <div>176 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}